const FRONT_META_ARRAY: { [key: string]: string }[] = [
  {
    meta: 'F-9999',
    pattern: 'timeOut',
  },
  {
    meta: 'F-9998',
    pattern: 'notData',
  },
  {
    meta: 'F-9997',
    pattern: 'unGzipError',
  },
  {
    meta: 'F-9996',
    pattern: 'notChildData',
  },
  {
    meta: 'F-9995',
    pattern: 'incompleteData',
  },
  {
    meta: 'F-9994',
    pattern: 'gzipError',
  },
]

export const getFrontMeta = (pattern: string) => {
  const targetObj = FRONT_META_ARRAY.find(
    (metaObj: { [key: string]: string }) => metaObj.pattern === pattern
  )

  return targetObj ? targetObj.meta : pattern ? pattern : 'F-10000'
}
